import styled from 'styled-components';

export const List = styled.div.withConfig({ displayName: '-List' })`
	overflow: hidden auto;
	background-color: #ffffff;
	flex-grow: 1;
	flex-shrink: 1;
	height: calc(100% - 106px);
`;
